export const earn = {
  jdzb: "Простой заработок",
  jryd: "Финансовый путь — вместе к успеху",
  jrbk: "Присоединяйтесь к простому заработку Biking: безграничные инновации для максимальной выгоды от ваших цифровых активов.",
  zbz: "В процессе заработка",
  ljsy: "Общий доход",
  zrsy: "Доход за вчера",
  hq: "До востребования",
  dq: "Срочный",
  cknh: "Справочная годовая ставка",
  sqjd: "Прогресс подписки",
  sg: "Подписаться",
  qbcp: "Все продукты",
  cz: "Сбросить",
  qx: "Срок",
  question1: "1. Что такое «Заработок»?",
  question1_text: "Заработок — это универсальная платформа BIKING, которая помогает пользователям находить различные возможности для хранения монет с получением дохода. В настоящее время предлагается простой заработок (с возможностью пополнения и вывода в любое время), в будущем появятся другие продукты.",
  question2: "2. Что такое справочная годовая ставка?",
  question2_text: "Доход от заработка — это проценты по внесённым токенам. Справочная годовая ставка — это годовая процентная ставка. Например: на первые 1000 U — 12%, на сумму сверх 1000 U — 2%, общая справочная годовая ставка — 14%.",
  question3: "3. Когда начинается начисление и выплата процентов?",
  question3_text: "Время начала начисления/выплаты процентов может различаться в зависимости от продукта. На примере USDT с ежедневным начислением: покупка продукта «до востребования» — проценты начисляются на следующий день в 2:00 (UTC+8), выплата процентов за предыдущий день происходит в 5:00 дня T+1 (т.е. покупка в T, выплата в T+2).",
  question4: "4. Что такое «Остаток для подписки»?",
  question4_text: "Остаток для подписки — это сумма, которую вы ещё можете вложить в продукт.<br/>Остаток = Общий лимит продукта − Уже вложенная вами сумма.",
  xzmbfs: "Выберите способ пополнения/покупки",
  nhsyl: "Годовая доходность и срок:",
  sl: "Количество",
  qitou: "Мин. сумма",
  max: "Макс.",
  kzcsl: "Доступно для перевода с капитального счёта",
  sykt: "Остаток для подписки",
  syktsl: "Сколько ещё вы можете подписать",
  syktsx: "Остаток для подписки = Общий лимит продукта − Уже подписанная вами сумма (не более лимита на пользователя {amount}{coin})",
  jlgz: "Правила вознаграждения",
  jd1: "Ступень 1: первые {amount}{coin}",
  ptjl: "Вознаграждение платформы",
  jd2: "Ступень 2: сверх первых {amount}{coin}",
  jd22: "Ступень",
  jd3: "Ступень 3: более {amount}{coin}",
  grsgsx: "Лимит на пользователя: {amount}{coin}",
  gz: "Правила",
  sgsj: "Время подписки",
  xianzai: "Сейчас",
  qxsj: "Начисление процентов с",
  lxrz: "Зачисление процентов",
  c2c: "Купить C2C",
  lhxz: "Гибкий выбор, лучшая цена",
  lcjd: "Простой процесс, быстрое исполнение",
  crszhb: "Внесите криптовалюту из кошелька или с биржи",
  zcsl: "Количество активов",
  dzsy: "Доход к зачислению",
  lcxx: "Информация о продукте",
  zt: "Статус",
  sh: "Погасить",
  sgje: "Сумма подписки",
  sgzj: "Сумма подписки: первые {amount}{coin} приносят {value}% годовых",
  dyklqje: "Сумма сверх {amount}{coin} приносит {value}% годовых",
  grsged: "Лимит подписки: от {amount} до {amount2}{coin}",
  shsl: "Сумма погашения",
  srshsl: "Введите сумму погашения",
  ksh: "Доступно для погашения:",
  haode: "Хорошо",
  sgcg: "Подписка успешна",
  shcg: "Погашение успешно",
  zcsg: "Новая подписка",
  sjdzsl: "Фактически зачислено",
  shsj: "Время погашения",
  jssj: "Время расчёта",
  yjsdd: "Расчётные ордера",
  jyjl: "История операций",
  hqjdzb: "Простой заработок до востребования",
  sy: "Доход",
  wwc: "Не завершён",
  xmlx: "Тип продукта",
  hqjdzbcp: "Простой заработок до востребования — безопасный финансовый продукт Biking с пополнением и выводом 24/7 и почасовым начислением процентов.",
  nh: "Годовая ставка",
  zhzchz: "Перевод средств между счетами — просто и быстро",
  qsrsl: "Введите количество",
  yjssymx: "Детали выплаченного дохода",
  mx: "Детали",
  qwsmrz: "Пройти верификацию",
  jxwcsmrz: "1. В акции участвуют только верифицированные пользователи, каждый может участвовать один раз.",
  dqcked: "2. Лимит срочного депозита для каждого пользователя: {min}~{max}{coin}. По истечении срока сумма автоматически возвращается на счёт.",
  cpbntjsh: "3. Досрочное погашение невозможно.",
  anzh: "4. Когда общий лимит продукта выбран, кнопка становится неактивной.",
  smrzyh: "Акция только для верифицированных пользователей.",
  jxcjyc: "Каждый подходящий пользователь может участвовать один раз.",
  ygsy: "Предполагаемый доход",
  scqx: "Срок блокировки",
  qixian: "День {min} (всего {max} дней)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/ru.js